<template>
  <div class="MyAccountPage_Overview">
    <transition name="fade" mode="out-in" v-if="isLoading">
      <app-loading
        :is-loading="isLoading"
        :spinner-color="'#1474a4'"
      />
    </transition>

    <template v-else>
      <div class="SubscriptionList" v-if="subscriptions.length">
        <payment-due
          :billings = this.hasBalanceInvoices
          v-if="isShowPastDueSection"
        />
    <template>
      <div class="Air" v-if="currentCountryCode === 'PL'">
        <div class="Air_title">
          <p>
            {{ $t('myaccount.paymentDetails.paymentDue.titleAir', 'Your rental account for Philips Air Purifiers has been moved') }}
          <a
           
           target="_blank"
          :href="$t('myaccount.paymentDetails.paymentAir', '##')">{{ $t('myaccount.paymentDetails.paymentAirlink', 'here') }}
          </a>
          </p>      
        </div>
      </div>
  </template>

        <section class="SubscriptionList-type SubscriptionList-active" v-if="activeSubscriptions.length">
          <h2 class="title" :class="{ 'hasOpenBlance': totalOpenBalance }">
            <span>
              {{ $t('myaccount.overview.activeSubscription.title', 'Active subscriptions') }}
            </span>
            <span v-if="loginRole === 'admin' && totalOpenBalance" class="balance-open">
              {{ $t('myaccount.overview.openBalance.title', 'Balance: - ') }} {{ totalOpenBalance | formatCurrency }}
            </span>
          </h2>

          <div
            class="ProductItem onlyReplenshipReturnStatusActive replenshipCancelAndReturnStatusActive"
            v-for="(subscription, index) in activeSubscriptions"
            :key="index"
            :isBCBSSubscription="subscription.isBCBSSubscription"
          >
            <template v-if="subscription.status === 'Active' || subscription.status === 'Paused'">
              <template v-if="subscription.replenishmentOnly">
                <p
                  class="tips_returnStatus"
                  v-if="subscription.replenishmentCancellationDate"
                  v-once>
                  <span>
                    <span>{{ $t('myaccount.overview.bundle.canceled.tips', 'Your') }}</span>
                    <span><b> {{ subscription.replenishmentRatePlanName }} </b></span>
                    <span>{{ $t('myaccount.overview.bundle.canceled.subTips', 'has been successfully cancelled.') }}</span>
                  </span>
                  <span class="closeButton" @click="closeReturnsubTipsActive(index)"></span>
                </p>
                <product
                  :image="subscription.image"
                  :isBCBSSubscription="subscription.isBCBSSubscription"
                  :name="subscription.title"
                  :monthly-charge="subscription.monthlyTotalCharge"
                  :quarterly-charge="subscription.quarterlyTotalCharge"
                  :semi-annual-charge="subscription.semiAnnualCharge"
                  :specific-months-charges="subscription.specificMonthsTotalCharges"
                  :next-shipment-date="subscription.nextShipmentDate"
                  :number="subscription.subscriptionNumber"
                  :list-shipping-frequency="subscription.shippingFrequency"
                  :replenshipment-returning-status="(subscription.status === 'Paused' &&
                  (subscription.replenishmentReturnInfo && subscription.replenishmentReturnInfo.returnStatus !=='Returning')) ? subscription.status : null"
                >
                  <template slot="more-info">
                    <div>
                      <p
                        class="Product_returnCreateDate info_item Product_info_align"
                        v-if="subscription.replenishmentCancellationDate &&
                      (subscription.replenishmentReturnInfo && subscription.replenishmentReturnInfo.returnStatus !== 'Returning')">
                        <span class="Product_info_warnBold">{{ $t('myaccount.overview.replenishmentCancelDate', 'Replenishment cancelled') }}:</span>
                        <span>{{ subscription.replenishmentCancellationDate | formatLocalDate }}</span>
                      </p>
                    </div>
                    <p class="link info_item linkToSubscriptionDetail" v-if=" currentCountryCode === 'PL' && subscription.title === null || currentCountryCode === 'PL' && !subscription.title.includes('Oczyszczacz powietrza') || currentCountryCode !== 'PL'">
                      <router-link
                        :to="{ name: 'subscription-details', params: { id: subscription.subscriptionNumber }, query: { language: queryLanguage } }"
                        @click.native="trackConversion({ name: 'interaction', description: 'subscription_details' })"
                      >
                        {{ $t('myaccount.overview.link.subscriptionDetails', 'Subscription details') }} ›
                      </router-link>
                    </p>

                    <p class="link info_item" v-if="subscription.ableToPayInFull">
                      <span
                        class="AppButton button-orange hide-mobile"
                        :class="{'grey-color': paymentActivity.hasPaymentInProgress}"
                        @mouseover="mouseover(subscription.subscriptionNumber)"
                        @mouseleave="mouseleave(subscription.subscriptionNumber)"
                        @click="trackConversion({ name: 'interaction', description: `buy_now:subscription_${index + 1}` }), redirectToSubscriptionDetails(subscription.subscriptionNumber)"
                      >
                        {{ $t('myaccount.overview.button', 'Pay in full now') }}
                      </span>
                      <v-popover
                        offset="15"
                        trigger="manual"
                        placement="bottom-right"
                        :open="isOpen && !!openGroups[subscription.subscriptionNumber]"
                        popover-wrapper-class="hide-mobile"
                        popover-inner-class="overview_poptip"
                      >
                        <template slot="popover">
                          <div>{{ $t('common.paymentInprogress.toolTips.text', 'This option is disabled as we are processing your latest payment') }}</div>
                        </template>
                      </v-popover>
                    </p>
                  </template>
                  <template slot="below_price_information">
                    <div>
                      <p
                        class="Product_returnStatus info_item Product_info_align"
                        v-if="(subscription.replenishmentReturnInfo &&
                        subscription.replenishmentReturnInfo.returnStatus ==='Returning')">
                        <span>{{ $t('subscription_return.confirmation.returnStatus.text', 'Status') }}:</span>
                        <span><i class="Product_returnCreateDate-warning"> {{ $t('subscription_return.bundles.confirmation.status.replenshipment.status.Returning', 'Waiting for replenishment return') }}</i></span>
                      </p>
                    </div>
                  </template>
                </product>
              </template>
              <template v-if="!subscription.replenishmentOnly">
                <template>
                  <p
                    class="tips_returnStatus"
                    v-if="subscription.tryBuyCancellationDate"
                    v-once>
                    <span>
                      <span>{{ $t('myaccount.overview.bundle.canceled.tips', 'Your') }}</span>
                      <span><b> {{ subscription.tryBuyRatePlanName }} </b></span>
                      <span>{{ $t('myaccount.overview.bundle.canceled.subTips', 'has been successfully cancelled.') }}</span>
                    </span>
                    <span class="closeButton" @click="closeReturnTipsActive(index)"></span>
                  </p>
                  <p
                    class="tips_returnStatus"
                    v-if="subscription.replenishmentCancellationDate"
                    v-once>
                    <span>
                      <span>{{ $t('myaccount.overview.bundle.canceled.tips', 'Your') }}</span>
                      <span><b> {{ subscription.replenishmentRatePlanName }} </b></span>
                      <span>{{ $t('myaccount.overview.bundle.canceled.subTips', 'has been successfully cancelled.') }}</span>
                    </span>
                    <span class="closeButton" @click="closeReturnsubTipsActive(index)"></span>
                  </p>
                  <product
                    :image="subscription.image"
                    :isBCBSSubscription="subscription.isBCBSSubscription"
                    :name="subscription.title"
                    :monthly-charge="subscription.monthlyTotalCharge"
                    :quarterly-charge="subscription.quarterlyTotalCharge"
                    :semi-annual-charge="subscription.semiAnnualCharge"
                    :specific-months-charges="subscription.specificMonthsTotalCharges"
                    :start-date="subscription.subscriptionStartDate"
                    :device-purchase-date="subscription.payInFullDate"
                    :next-shipment-date="subscription.nextShipmentDate"
                    :number="subscription.subscriptionNumber"
                    :device-return-create-date="subscription.tryBuyCancellationDate ? null : subscription.tryBuyReturnInfo && subscription.tryBuyReturnInfo.returnCreatedDate"
                    :replenshipment-return-create-date="subscription.replenishmentCancellationDate ? null : subscription.replenishmentReturnInfo && subscription.replenishmentReturnInfo.returnCreatedDate"
                  >
                    <template slot="below_price_information">
                      <div>
                        <p
                          class="Product_returnStatus info_item Product_info_align"
                          v-if="subscription.tryBuyReturnInfo && subscription.replenishmentReturnInfo &&
                            subscription.tryBuyReturnInfo.returnStatus === 'Returning' &&
                          subscription.replenishmentReturnInfo.returnStatus === 'Returning'">
                          <span>{{ $t('subscription_return.confirmation.returnStatus.text', 'Status') }}:</span>
                          <span><i class="Product_returnCreateDate-warning"> {{ $t('subscription_return.confirmation.status.deviceAndReplenshipment.bothReturn.status.Returning', 'Waiting for returns') }}</i></span>
                        </p>
                        <p
                          class="Product_returnStatus info_item Product_info_align"
                          v-if="subscription.tryBuyRatePlanName && subscription.replenishmentRatePlanName &&
                            (subscription.tryBuyReturnInfo && subscription.tryBuyReturnInfo.returnStatus ==='Returning') &&
                        (subscription.replenishmentReturnInfo && subscription.replenishmentReturnInfo.returnStatus !=='Returning')">
                          <span>{{ $t('subscription_return.confirmation.returnStatus.text', 'Status') }}:</span>
                          <span><i class="Product_returnCreateDate-warning"> {{ $t('subscription_return.confirmation.status.deviceAndReplenshipment.device.status.Returning', 'Waiting for device return') }}</i></span>
                        </p>
                        <p
                          class="Product_returnStatus info_item Product_info_align"
                          v-if="subscription.tryBuyReturnInfo && subscription.replenishmentReturnInfo &&
                            (subscription.replenishmentReturnInfo && subscription.replenishmentReturnInfo.returnStatus ==='Returning') &&
                        (subscription.tryBuyReturnInfo && subscription.tryBuyReturnInfo.returnStatus !=='Returning')">
                          <span>{{ $t('subscription_return.confirmation.returnStatus.text', 'Status') }}:</span>
                          <span><i class="Product_returnCreateDate-warning"> {{ $t('subscription_return.bundles.confirmation.status.replenshipment.status.Returning', 'Waiting for replenishment return') }}</i></span>
                        </p>
                        <p
                          class="Product_returnStatus info_item Product_info_align"
                          v-if="subscription.tryBuyReturnInfo && !subscription.replenishmentReturnInfo &&
                        (subscription.tryBuyReturnInfo && subscription.tryBuyReturnInfo.returnStatus ==='Returning')">
                          <span>{{ $t('subscription_return.confirmation.returnStatus.text', 'Status') }}:</span>
                          <span><i class="Product_returnCreateDate-warning"> {{ $t('subscription_return.confirmation.status.onlyDevice.status.Returning', 'Waiting for device return') }}</i></span>
                        </p>
                      </div>
                    </template>
                    <template slot="more-info">
                      <div>
                        <p class="Product_returnCreateDate info_item Product_info_align" v-if="subscription.tryBuyCancellationDate">
                          <span class="Product_info_warnBold">
                            {{ $t('myaccount.overview.deviceCancelDate', 'Device cancelled') }}:
                          </span>
                          <span>{{ subscription.tryBuyCancellationDate | formatLocalDate }}</span>
                        </p>
                        <p
                          class="Product_returnCreateDate info_item Product_info_align"
                          v-if="subscription.replenishmentCancellationDate">
                          <span class="Product_info_warnBold">{{ $t('myaccount.overview.replenishmentCancelDate', 'Replenishment cancelled') }}:</span>
                          <span>{{ subscription.replenishmentCancellationDate | formatLocalDate }}</span>
                        </p>
                      </div>
                      <p class="link info_item linkToSubscriptionDetail" v-if=" currentCountryCode === 'PL' && subscription.title === null || currentCountryCode === 'PL' && !subscription.title.includes('Oczyszczacz powietrza') || currentCountryCode !== 'PL'">
                        <router-link
                          :to="{ name: 'subscription-details', params: { id: subscription.subscriptionNumber }, query: { language: queryLanguage } }"
                          @click.native="trackConversion({ name: 'interaction', description: 'subscription_details' })"
                        >
                          {{ $t('myaccount.overview.link.subscriptionDetails', 'Subscription details') }} ›
                        </router-link>
                      </p>

                      <p class="link info_item" v-if="subscription.ableToPayInFull">
                        <span
                          :class="{'grey-color': paymentActivity.hasPaymentInProgress}"
                          @mouseover="mouseover(subscription.subscriptionNumber)"
                          @mouseleave="mouseleave(subscription.subscriptionNumber)"
                          class="AppButton button-orange hide-mobile"
                          @click="redirectToSubscriptionDetails(subscription.subscriptionNumber), trackConversion({ name: 'interaction', description: `buy_now:subscription_${index + 1}` })"
                        >
                          {{ $t('myaccount.overview.button', 'Pay in full now') }}
                        </span>
                        <v-popover
                          offset="15"
                          trigger="manual"
                          placement="bottom-right"
                          :open="isOpen && !!openGroups[subscription.subscriptionNumber]"
                          popover-wrapper-class="overview_poptip"
                        >
                          <template slot="popover">
                            <div>{{ $t('common.paymentInprogress.toolTips.text', 'This option is disabled as we are processing your latest payment') }}</div>
                          </template>
                        </v-popover>
                      </p>
                    </template>
                  </product>
                </template>
              </template>

              <span
                v-if="subscription.ableToPayInFull"
                class="AppButton button-orange show-mobile"
                :class="{'grey-color': paymentActivity.hasPaymentInProgress}"
                @mouseover="mouseover(subscription.subscriptionNumber)"
                @mouseleave="mouseleave(subscription.subscriptionNumber)"
                @click="trackConversion({ name: 'interaction', description: `buy_now:subscription_${index + 1}` }), redirectToSubscriptionDetails(subscription.subscriptionNumber)"
              >
                {{ $t('myaccount.overview.button', 'Pay in full now') }}
              </span>
              <v-popover
                offset="15"
                trigger="manual"
                placement="bottom-right"
                :open="isOpen && !!openGroups[subscription.subscriptionNumber]"
                popover-wrapper-class="overview_poptip_mobile"
              >
                <template slot="popover">
                  <div>{{ $t('common.paymentInprogress.toolTips.text', 'This option is disabled as we are processing your latest payment') }}</div>
                </template>
              </v-popover>
            </template>

            <div class="ProductItem-creating" v-else>
              <span class="ProductItem-creating_img"></span>
              <div class="ProductItem-creating_content">
                <h3 class="emptyTitle">
                  {{ $t('common.product.productCreating.title', 'Pending subscription/ subscription is being created') }}
                </h3>
                <span class="emptyBox"></span>
                <span class="emptyBox"></span>
                <span class="emptyBox"></span>
              </div>
            </div>
          </div>
        </section>

        <section class="SubscriptionList-type SubscriptionList-inactive" v-if="inactiveSubscriptions.length">
          <h2 class="title">
            {{ $t('myaccount.overview.inactiveSubscription.title', 'Inactive subscriptions') }}
          </h2>

          <div
            class="ProductItem onlyReplenshipReturnStatus replenshipCancelAndReturnStatus"
            v-for="(subscription, index) in inactiveSubscriptions"
            :key="index"
          >
            <template v-if="subscription.replenishmentOnly">
              <p
                class="tips_returnStatus"
                v-if="((subscription.replenishmentReturnInfo &&
                  (subscription.replenishmentReturnInfo.returnStatus === 'Not return' ||
                subscription.replenishmentCancellationDate && subscription.replenishmentReturnInfo.returnStatus === 'None')))"
                v-once>
                <span>
                  {{ $t('myaccount.overview.onlyReplenishment.cancelAndNotReturn.tips', 'Your') }}
                  <b> {{ subscription.replenishmentRatePlanName }} </b>
                  {{ $t('myaccount.overview.onlyReplenishment.cancelAndNotReturn.subTips', 'has been successfully cancelled.') }}
                </span>
                <span class="closeButton" @click="closeReturnTips(index)"></span>
              </p>
              <p
                class="tips_returnStatus"
                v-if="subscription.isCancelled &&
                subscription.replenishmentReturnInfo && subscription.replenishmentReturnInfo.returnStatus ==='Returning'"
                v-once>
                <span>
                  {{ $t('myaccount.overview.onlyReplenishment.cancelAndReturn.tips', 'We have received your') }}
                  <b>{{ subscription.replenishmentRatePlanName }}</b>
                  {{ $t('myaccount.overview.onlyReplenishment.cancelAndReturn.subTips', 'back and cancelled your subscription') }}
                </span>
                <span class="closeButton" @click="closeReturnTips(index)"></span>
              </p>
            </template>

            <template v-else>
              <p
                class="tips_returnStatus"
                v-if="(subscription.isCancelled && subscription.tryBuyCancellationDate)"
                v-once>
                <span>
                  {{ $t('myaccount.overview.notOnlyReplenishment.canceled.tips', 'We have received your') }}
                  <b> {{ subscription.tryBuyRatePlanName }} </b>
                  {{ $t('myaccount.overview.notOnlyReplenishment.canceled.subTips', 'back and cancelled your subscription') }}
                </span>
                <span class="closeButton" @click="closeReturnTips(index)"></span>
              </p>
              <p
                class="tips_returnStatus"
                v-if="(subscription.isCancelled && subscription.replenishmentCancellationDate)"
                v-once>
                <span>
                  {{ $t('myaccount.overview.notOnlyReplenishment.canceled.tips', 'We have received your') }}
                  <b> {{ subscription.replenishmentRatePlanName }} </b>
                  {{ $t('myaccount.overview.notOnlyReplenishment.canceled.subTips', 'back and cancelled your subscription') }}
                </span>
                <span class="closeButton" @click="closeReturnsubTips(index)"></span>
              </p>
              <p
                class="tips_returnStatus"
                v-if="(!subscription.isCancelled && subscription.tryBuyCancellationDate)"
                v-once>
                <span>
                  {{ $t('myaccount.overview.notOnlyReplenishment.canceled.tips', 'Your') }}
                  <b> {{ subscription.tryBuyRatePlanName }} </b>
                  {{ $t('myaccount.overview.notOnlyReplenishment.canceled.subTips', 'subscription has been successfully cancelled.') }}
                </span>
                <span class="closeButton" @click="closeReturnTips(index)"></span>
              </p>
              <p
                class="tips_returnStatus"
                v-if="(!subscription.isCancelled && subscription.replenishmentCancellationDate)"
                v-once>
                <span>
                  {{ $t('myaccount.overview.notOnlyReplenishment.canceled.tips', 'Your') }}
                  <b> {{ subscription.replenishmentRatePlanName }} </b>
                  {{ $t('myaccount.overview.notOnlyReplenishment.canceled.subTips', 'subscription has been successfully cancelled.') }}
                </span>
                <span class="closeButton" @click="closeReturnsubTips(index)"></span>
              </p>
            </template>

            <template v-if="subscription.replenishmentOnly">
              <product
                :image="subscription.image"
                :name="subscription.title"
                :number="subscription.subscriptionNumber"
                :isBCBSSubscription="subscription.isBCBSSubscription"
              >
                <template slot="independent-information">
                  <div>
                    <p
                      class="Product_returnCreateDate info_item Product_returnStatus Product_info_align"
                      v-if="(!subscription.isCancelled &&
                    (subscription.replenshipmentReturnInfo && subscription.replenshipmentReturnInfo.returnStatus === 'Returning'))">
                      <span>
                        {{ $t('myaccount.overview.onlyReplenishment.status.label', 'Status') }}:
                      </span>
                      <span class="Product_returnCreateDate-warning">
                        {{ $t('myaccount.overview.onlyReplenishment.status.text', 'Waiting for replenishment return') }}
                      </span>
                    </p>
                  </div>
                </template>
                <template slot="more-info">
                  <div v-if="subscription.replenishmentCancellationDate">
                    <p class="Product_returnCreateDate info_item Product_info_align">
                      <span class="Product_info_warnBold">{{ $t('myaccount.overview.inactiveSubscription.onlyReplenishment.cancelledDate', 'Replenishment cancelled') }}:</span>
                      <span>{{ subscription.replenishmentCancellationDate | formatLocalDate }}</span>
                    </p>
                  </div>
                  <p class="link info_item linkToSubscriptionDetail" v-if=" currentCountryCode === 'PL' && subscription.title === null || currentCountryCode === 'PL' && !subscription.title.includes('Oczyszczacz powietrza') || currentCountryCode !== 'PL'">
                    <router-link
                      :to="{ name: 'subscription-details', params: { id: subscription.subscriptionNumber }, query: { language: queryLanguage } }"
                      @click.native="trackConversion({ name: 'interaction', description: 'subscription_details' })"
                    >
                      {{ $t('myaccount.overview.link.subscriptionDetails', 'Subscription details') }} ›
                    </router-link>
                  </p>
                </template>
                <template slot="below_price_information">
                  <div>
                    <p class="Product_returnStatus info_item Product_info_align" v-if="(subscription.replenishmentReturnInfo && subscription.replenishmentReturnInfo.returnStatus ==='Returning')">
                      <span>{{ $t('subscription_return.confirmation.returnStatus.text', 'Status') }}:</span>
                      <span><i class="Product_returnCreateDate-warning"> {{ $t('subscription_return.confirmation.status.onlyReplenshipment.status.Returning', 'Waiting for replenshipment return') }}</i></span>
                    </p>
                  </div>
                </template>
              </product>
            </template>

            <!-- not only replenishment -->
            <template v-if="!subscription.replenishmentOnly">
              <product
                :image="subscription.image"
                :isBCBSSubscription="subscription.isBCBSSubscription"
                :name="subscription.title"
                :monthly-charge="subscription.monthlyTotalCharge"
                :quarterly-charge="subscription.quarterlyTotalCharge"
                :semi-annual-charge="subscription.semiAnnualCharge"
                :specific-months-charges="subscription.specificMonthsTotalCharges"
                :number="subscription.subscriptionNumber"
                :device-purchase-date="subscription.payInFullDate"
                :next-shipment-date="subscription.nextShipmentDate"
                :start-date="subscription.payInFullDate ? null : subscription.subscriptionStartDate"
              >
                <template slot="more-info">
                  <div>
                    <p class="Product_returnCreateDate info_item Product_info_align" v-if="subscription.tryBuyCancellationDate">
                      <span class="Product_info_warnBold">{{ $t('myaccount.overview.deviceCancelDate', 'Device cancelled') }}:</span>
                      <span>{{ subscription.tryBuyCancellationDate | formatLocalDate }}</span>
                    </p>
                    <p class="Product_returnCreateDate info_item Product_info_align" v-if="subscription.replenishmentCancellationDate">
                      <span class="Product_info_warnBold">{{ $t('myaccount.overview.replenishmentCancelDate', 'Replenishment cancelled') }}:</span>
                      <span>{{ subscription.replenishmentCancellationDate | formatLocalDate }}</span>
                    </p>
                  </div>
                  <p class="link info_item linkToSubscriptionDetail" v-if=" currentCountryCode === 'PL' && subscription.title === null || currentCountryCode === 'PL' && !subscription.title.includes('Oczyszczacz powietrza') || currentCountryCode !== 'PL'">
                    <router-link
                      :to="{ name: 'subscription-details', params: { id: subscription.subscriptionNumber }, query: { language: queryLanguage } }"
                      @click.native="trackConversion({ name: 'interaction', description: 'subscription_details' })"
                    >
                      {{ $t('myaccount.overview.link.subscriptionDetails', 'Subscription details') }} ›
                    </router-link>
                  </p>
                </template>
              </product>
            </template>
          </div>
        </section>
      </div>

      <p v-else class="empty-data">
        {{ $t('myaccount.overview.body.emptyData', 'You have no subscriptions or your subscriptions have not synchronize yet') }}
      </p>
    </template>
  </div>
</template>

<script>
  import Product from 'components/Product'
  import { mapState, mapGetters } from 'vuex'
  import { extractErrorMessage } from '@/utilities/common'
  import paymentDue from 'components/PaymentDue'
  import { detectedCulture } from '@/utilities/common/culture'
  

  export default {
    name: 'overview',

    components: {
      Product,
      paymentDue
    },

    data () {
      return {
        isLoading: true,
        loginRole: window.localStorage.getItem('loginRole') || 'user',
        billings: [],
        isOpen: false,
        openGroups: [],
        currentCountryCode: detectedCulture.countryCode,
        detectedCulture: detectedCulture, 
        bundlesInfor :  window.sessionStorage.getItem('bundlesInfor')
      }
    },
     mounted () {  
       
          this.survey ()   

    },

    computed: {
      ...mapState('subscription', ['subscriptions']),
      ...mapGetters('account', ['openBalanceInvocies', 'isShowPastDueSection', 'billingInvoices']),
      ...mapState('account', {
        paymentActivity: state => state.paymentActivity
      }),
      ...mapState('checkout', {  
        cartDetails: state => state.cartDetails 
      }),

      activeSubscriptions () {
        return this.subscriptions.filter(subscription => subscription.status !== 'InActive')
      },

      inactiveSubscriptions () {
        return this.subscriptions.filter(subscription => subscription.status === 'InActive')
      },

      totalOpenBalance () {
        return this.openBalanceInvocies.length &&
          this.openBalanceInvocies.map(invocies => invocies.balance).reduce((acc, cur) => acc + cur, 0)
      },

      hasBalanceInvoices () {
        return this.billingInvoices.filter(item => item.hasBalance === true)
      },

      // Airpurifier () {
      //   return this.subscriptions.filter(subscription => subscription.title.includes('Oczyszczacz powietrza'))
      // },

      isCanadaSite () {
        return detectedCulture.code === 'en-ca'
      },

      isBelgiumSite () {
        return detectedCulture.code === 'nl-be'
      },

      queryLanguage () {
        if (this.isCanadaSite) {
          return window.localStorage.getItem('canadaLanguage')
        }
          if (this.isBelgiumSite) {
          return window.localStorage.getItem('belgiumLanguage')
        }
      }
    },

    methods: {
      closeReturnTips (index) {
        document.getElementsByClassName('onlyReplenshipReturnStatus')[index].children[0].style.display = 'none'
      },

      closeReturnsubTips (index) {
        if (document.querySelectorAll('.replenshipCancelAndReturnStatus')[index].children[1].className === 'tips_returnStatus') {
          document.querySelectorAll('.replenshipCancelAndReturnStatus')[index].children[1].style.display = 'none'
        } else {
          document.querySelectorAll('.replenshipCancelAndReturnStatus')[index].children[0].style.display = 'none'
        }
      },

      closeReturnTipsActive (index) {
        document.getElementsByClassName('onlyReplenshipReturnStatusActive')[index].children[0].style.display = 'none'
      },

      closeReturnsubTipsActive (index) {
        if (document.querySelectorAll('.replenshipCancelAndReturnStatusActive')[index].children[1].className === 'tips_returnStatus') {
          document.querySelectorAll('.replenshipCancelAndReturnStatusActive')[index].children[1].style.display = 'none'
        } else {
          document.querySelectorAll('.replenshipCancelAndReturnStatusActive')[index].children[0].style.display = 'none'
        }
      },

      mouseleave (subscriptionNumber) {
        if (this.paymentActivity.hasPaymentInProgress) {
          this.isOpen = false
          this.openGroups[subscriptionNumber] = false
        }
      },
      mouseover (subscriptionNumber) {
        if (this.paymentActivity.hasPaymentInProgress) {
          this.isOpen = true
          this.openGroups[subscriptionNumber] = true
        }
      },

      redirectToSubscriptionDetails (subscriptionNumber) {
        if (this.paymentActivity.hasPaymentInProgress) {
          return false
        } else {
          this.$router.replace({
            name: 'subscription-details',
            params: {
              id: subscriptionNumber
            }
          })
        }
      }
    },

    created () {
      this.$store.dispatch('subscription/fecthSubscriptions').then(() => {
        this.isLoading = false
        if (this.isCanadaSite) {
          if (!this.queryLanguage) {
            this.$router.push({
              query: {
                language: 'en-CA'
              }
            })
          } else {
            this.$router.push({
              query: {
                language: this.queryLanguage
              }
            })
          }
          window.localStorage.setItem('canadaLanguage', this.$route.query.language)
        }

        if (this.isBelgiumSite) {
          if (!this.queryLanguage) {
            this.$router.push({
              query: {
                language: 'nl-BE'
              }
            })
          } else {
            this.$router.push({
              query: {
                language: this.queryLanguage
              }
            })
          }
          window.localStorage.setItem('belgiumLanguage', this.$route.query.language)
        } 
      }).catch(error => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        }) 
      
      })
    }
  }
</script>

<style lang="scss">
  .MyAccountPage {
    &_Overview {
      .hide-tips {
        display: none;
      }

      .SubscriptionList {
        &-type {
          margin-bottom: .3rem;

          &:last-of-type {
            margin-bottom: 0;
          }
        }
      }

      .title {
        @include media(tablet) {
          border-bottom: .01rem solid $gray;
          margin-bottom: .15rem;
        }

        &.hasOpenBlance {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
        }
      }

      .ProductItem {
        margin-bottom: .15rem;
        padding: .2rem .1rem;
        background: $block-bg;
        border: .01rem solid #e8e8e8;

        @include media(tablet) {
          background: $white;
        }

        &:last-of-type {
          margin-bottom: 0;
        }

        .link {
          > a {
            line-height: 1.15;
            color: $blue;
            display: inline-flex;
            align-items: center;

            &.AppButton {
              color: $white;
            }
          }
        }

        .AppButton {
          margin-top: .1rem;
        }

        .tips_returnStatus {
          background-color: #f7fad4;
          font-size: .14rem;
          color: #5f9920;
          line-height: .22rem;
          padding: .11rem .16rem;
          max-width: 98%;

          @include media(tablet) {
            padding: .11rem .26rem;
          }

          span:nth-of-type(1) {
            @include media(tablet) {
              max-width: 98%;
              display: inline-block;
            }
          }
        }
      }

      .Product {
        padding: 0;

        &_info {
          @include media(tablet) {
            padding: 0 .1rem;
          }

          .Product_name {
            margin-bottom: .1rem;
          }
        }

        .Product_returnCreateDate-warning {
          font-weight: 500;
        }
      }

      .ProductItem-creating {
        display: flex;
        justify-content: space-around;

        &_img {
          background-color: $placeholder-gray;
          flex: 1;
          display: block;
        }

        &_content {
          flex: 2;
          padding: 0 .1rem;

          .emptyTitle {
            font-size: .14rem;
            font-weight: 400;
            text-align: center;
            color: $font-dark-gray;
            line-height: 1.4;
            padding: .05rem 0;
          }

          .emptyBox {
            background: $placeholder-gray;
            margin-top: .06rem;
            height: .22rem;
            display: block;

            @include media(tablet) {
              height: .37rem;
              margin-top: .1rem;
            }
          }
        }
      }

      .balance-open {
        font-weight: 500;
        font-size: .2rem;
        color: $pink;
        flex-grow: 1;
        text-align: right;
        margin-top: .05rem;

        @include media(tablet) {
          flex-grow: 0;
        }
      }

      .SubscriptionList-active {
        .tips_returnStatus {
          margin-bottom: .15rem;
          position: relative;
          max-width: 98%;

          .closeButton {
            position: absolute;
            right: -0.6rem;
            top: 39%;

            @include media(tablet) {
              right: -0.56rem;
              top: 32%;
            }
          }

          span:nth-of-type(1) {
            @include media(tablet) {
              max-width: 98%;
              display: inline-block;
            }
          }

          .closeButton::before,
          ::after {
            right: .5rem;
            top: 61%;
            background-color: #5f9920;
            cursor: pointer;

            @include media(tablet) {
              top: 62%;
            }
          }
        }
      }

      .SubscriptionList-inactive {
        .tips_returnStatus {
          margin-bottom: .15rem;
          position: relative;
          max-width: 98%;

          .closeButton {
            position: absolute;
            right: -0.6rem;
            top: 39%;

            @include media(tablet) {
              right: -0.56rem;
              top: 32%;
            }
          }

          span:nth-of-type(1) {
            @include media(tablet) {
              max-width: 98%;
              display: inline-block;
            }
          }

          .closeButton::before,
          ::after {
            right: 50px;
            top: 61%;
            background-color: #5f9920;
            cursor: pointer;

            @include media(tablet) {
              top: 62%;
            }
          }
        }
      }

      .Product_info_align {
        span:nth-of-type(2) {
          width: 40%;
        }

        span:nth-of-type(1) {
          max-width: 60%;
        }

        display: flex;
        justify-content: space-between;
      }

      .Product_returnStatus.Product_info_align {
        display: inline-block;
        margin: 0 0 .15rem;

        .Product_returnCreateDate-warning {
          font-weight: 500;
        }
      }

      .Product_payInfullDate {
        span:nth-of-type(1) {
          font-weight: 700;
          color: #212121;
        }
      }

      .linkToSubscriptionDetail {
        margin-top: .2rem;
      }
    }

    .grey-color {
      background: #d8d8d8 !important;
      cursor: default;
    }
  }

  .overview_poptip {
    top: -.33rem;
    left: 0;
    position: absolute;
    background: white;
    min-width: 2.09rem;
    display: none;

    @include media(tablet) {
      top: -.33rem;
      left: 0;
      position: absolute;
      background: white;
      min-width: 2.26rem;
      display: block;
    }

    @include media(desktop) {
      display: block;
    }

    .tooltip-arrow {
      @include media(tablet) {
        left: calc(20% - 9px) !important;
      }

      @include media(desktop) {
        left: calc(20% - 9px) !important;
      }
    }
  }

  .Air {
    border: .01rem solid #de7815;
    background-color: #fdf5d7;
    margin-bottom: .3rem;

    @include media(tablet) {
      margin-top: -.22rem;
    }

    &_title {
      padding: .15rem .16rem .25rem;
      color: #de7815;
    }

    p {
      font-size: .16rem;
      line-height: .22rem;
    }
  }

  .overview_poptip_mobile {
    top: -.33rem;
    left: 1rem;
    position: absolute;
    background: white;
    min-width: 2.09rem;
    display: block;

    @include media(tablet) {
      display: none;
    }

    @include media(desktop) {
      display: none;
    }

    .tooltip-arrow {
      @include media(tablet) {
        left: calc(20% - 9px) !important;
      }

      @include media(desktop) {
        left: calc(20% - 9px) !important;
      }
    }
  }
</style>
